import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

class ConfirmationDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            question: '',
            confirmCallback: undefined
        };

        this.onCancel = this.onCancel.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    onCancel() {
        this.setState({ show: false });
    }

    onConfirm() {
        this.setState({ show: false });
        if (this.state.confirmCallback) {
            this.state.confirmCallback();
        }
    }

    showDialog(question, confirmCallback) {
        this.setState({
            show: true,
            question: question,
            confirmCallback: typeof confirmCallback === 'function' ? confirmCallback : undefined
        });
    }

    render() {
        return (
            <Modal show={this.state.show} onHide={this.onCancel}>
                <Modal.Header>
                    <Modal.Title>{process.env.REACT_APP_WEBSITE_NAME}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.state.question}</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle='primary' onClick={this.onConfirm}>Yes</Button>
                    <Button onClick={this.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ConfirmationDialog;